module.exports = __webpack_public_path__ + "static/media/pinterest-f.94315817.svg";